import React from 'react';
import PropTypes from 'prop-types';
var CircularProgressBar = function CircularProgressBar(_ref) {
  var sqSize = _ref.sqSize,
    strokeWidth = _ref.strokeWidth,
    percentage = _ref.percentage,
    showPercentage = _ref.showPercentage;
  // Size of the enclosing square
  // SVG centers the stroke width on the radius, subtract out so circle fits in square
  var radius = (sqSize - strokeWidth) / 2;
  // Enclose cicle in a circumscribing square
  var viewBox = "0 0 ".concat(sqSize + 2, " ").concat(sqSize + 2);
  // Arc length at 100% coverage is the circle circumference
  var dashArray = radius * Math.PI * 2;
  // Scale 100% coverage overlay with the actual percent
  var dashOffset = dashArray - dashArray * (percentage / 100);
  return /*#__PURE__*/React.createElement("svg", {
    width: sqSize + 1,
    height: sqSize + 1,
    viewBox: viewBox
  }, /*#__PURE__*/React.createElement("circle", {
    className: "circular-progress-bar__background",
    cx: sqSize / 2,
    cy: sqSize / 2,
    r: radius,
    strokeWidth: "".concat(strokeWidth, "px")
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circular-progress-bar__progress",
    cx: sqSize / 2,
    cy: sqSize / 2,
    r: radius,
    strokeWidth: "".concat(strokeWidth + 1, "px")
    // Start progress marker at 12 O'Clock
    ,
    transform: "rotate(-90 ".concat(sqSize / 2, " ").concat(sqSize / 2, ")"),
    style: {
      strokeDasharray: dashArray,
      strokeDashoffset: dashOffset
    }
  }), showPercentage && /*#__PURE__*/React.createElement("text", {
    className: "circular-progress-bar__text",
    x: "50%",
    y: "50%",
    dy: ".3em",
    textAnchor: "middle"
  }, "".concat(Math.round(percentage), "%")));
};
CircularProgressBar.propTypes = {
  sqSize: PropTypes.number.isRequired,
  strokeWidth: PropTypes.number.isRequired,
  percentage: PropTypes.number.isRequired,
  showPercentage: PropTypes.bool
};
CircularProgressBar.defaultProps = {
  showPercentage: false
};
export default CircularProgressBar;